import axios from "axios";

// TODO: get Token from sessionStorage
const stage = process.env.REACT_APP_STAGE || "dev";
const client = axios.create({
    baseURL: stage === "dev" ? process.env.REACT_APP_BASE_URL_DEV : process.env.REACT_APP_BASE_URL_PROD,
});
const clientSmi = axios.create({
    baseURL: stage === "dev" ? process.env.REACT_APP_BASE_URL_DEV_SMI : process.env.REACT_APP_BASE_URL_PROD_SMI,
});

const injectAuthToken = (config) => {
    const token = localStorage.getItem("userToken");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

client.interceptors.request.use(injectAuthToken, (error) => Promise.reject(error));
clientSmi.interceptors.request.use(injectAuthToken, (error) => Promise.reject(error));

export const getData = async (endPoint, {params, ...rest}) => {
    try {
        const response = await client.get(endPoint, {params, ...rest});
        return response.data;
    } catch (err) {
        throw err;
        // return err;
    }
};

export const postData = async (endPoint, {data, ...rest}) => {
    try {
        const response = await client.get(endPoint, {data, ...rest});
        return response.data;
    } catch (err) {
        return err;
    }
};

export const postDataSmi = async (endPoint, {data, ...rest}) => {
    try {
        const response = await clientSmi.post(endPoint, {data, ...rest});
        return response.data;
    } catch (err) {
        return err;
    }
};
